var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M13.75 8.125H4.0625L3.27513 2.3882C3.24894 2.24419 3.17305 2.11394 3.06067 2.02016C2.9483 1.92637 2.80658 1.875 2.66021 1.875H1.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M6.25 17.5C7.11294 17.5 7.8125 16.8004 7.8125 15.9375C7.8125 15.0746 7.11294 14.375 6.25 14.375C5.38706 14.375 4.6875 15.0746 4.6875 15.9375C4.6875 16.8004 5.38706 17.5 6.25 17.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14.375 17.5C15.2379 17.5 15.9375 16.8004 15.9375 15.9375C15.9375 15.0746 15.2379 14.375 14.375 14.375C13.5121 14.375 12.8125 15.0746 12.8125 15.9375C12.8125 16.8004 13.5121 17.5 14.375 17.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M4.88636 11.25H14.6954C14.9882 11.25 15.2716 11.1473 15.4963 10.9597C15.7211 10.7721 15.8729 10.5116 15.9253 10.2236L16.875 5H3.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shoppingCart.241a22d0958661129188b6e6d245d3e0.svg";
export { ForwardRef as ReactComponent };